<template lang="pug">
  v-layout(row wrap)
    v-form.mr-2(ref="form" v-model="valid")
      v-flex(xs12 mt-2)
        v-layout(row wrap)
          v-flex(xs10 offset-xs1)
            h3 Please select the industry that most closely fits your work.
          v-flex(xs5 offset-xs1)
            v-select(
              label="Select your industry"
              v-model="form.industry"
              :rules="[rules.required]"
              :items="industries"
              required
            )
      v-flex(xs12 mt-2)
        v-layout(wrap)
          v-flex.row-thin(xs10 offset-xs1)
            h3.mb-2 Campaign use case description (describe what you will be using this campaign use case for)
              |
              | Example: Marketing messages
            v-textarea(
              label="Description"
              v-model="form.useCase"
              :rules="[rules.required, rules.minLength(40), rules.maxLength(4096)]"
              :outline="true"
              browser-autocomplete="disable"
              required
              rows=1
              no-resize
            )
      v-flex(xs12 mt-2)
        v-layout(wrap)
          v-flex.row-thin(xs10 offset-xs1)
            h3.mb-2 Campaign Sample Messages
            p Provide an example of a message that you will be sending with this campaign use case. This message sample will be used by carriers to help identify your traffic.
            p Example: Hi &lt;&lt;User Name&gt;&gt; a new listing just opened up near your area of interest, reply if you want more details or I can show you the open house. Reply STOP to OPT Out.
      v-flex(xs12 mt-2)
        v-layout(wrap)
          v-flex(xs10 offset-xs1)
            h3.row-thin.mb-1 Sample message #1
            v-textarea(
              label="Description"
              v-model="form.sample1"
              :rules="[rules.required, rules.minLength(20), rules.maxLength(1024)]"
              :outline="true"
              browser-autocomplete="disable"
              required
              rows=1
              no-resize
            )
          v-flex(xs10 offset-xs1)
            h3.row-thin.mb-1 Sample message #2
            v-textarea(
              label="Description"
              v-model="form.sample2"
              :rules="[rules.required, rules.minLength(20), rules.maxLength(1024)]"
              :outline="true"
              browser-autocomplete="disable"
              required
              rows=1
              no-resize
            )
      v-flex.actions(xs12)
        v-btn(v-if="!isFixCampaign && !isLoading" color="primary" outline data-cy="back-brand-form" @click="back") Back to Brand
        v-btn(
          v-if="!isFixCampaign && !isLoading"
          color="primary"
          data-cy="a2p-submit"
          :disabled="shouldDisableSubmitButton"
          @click="submit"
        ) Submit
        v-btn.retry-button(
          v-else-if="!isLoading"
          color="primary"
          data-cy="a2p-submit"
          :disabled="shouldDisableSubmitButton"
          @click="submit"
        ) Fix message types
        v-progress-circular(v-else indeterminate color="primary")
</template>
<script>
import { mapMutations, mapActions, mapGetters, mapState } from 'vuex';
import { STEPS_SOLE_PROPRIETOR, INDUSTRIES } from '../config';

export default {
  name: 'CampaignSoleProprietor',
  props: {
    disableSubmit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      valid: false,
      form: {
        industry: null,
        useCase: null,
        sample1: null,
        sample2: null,
      },
      rules: {
        required: value => {
          return !!value || 'This field is required';
        },
        maxLength(max) {
          return value => (value && value.length <= max) || `Max ${max} characters`;
        },
        minLength(min) {
          return value => (value && value.length >= min) || `Min ${min} characters`;
        },
      },
      steps: STEPS_SOLE_PROPRIETOR,
      industries: INDUSTRIES,
    };
  },
  async mounted() {
    if (!this.registerForm) {
      await this.getRegistrationData('sole_proprietor');
    }
    if (!this.registerForm) {
      await this.getRegistrationData('starter');
    }
    await this.getForm();
  },
  computed: {
    ...mapState('conversations', [
      'registrationStatus10dlc',
    ]),
    ...mapState('registerSoleProprietorA2p', ['registerForm', 'preloadedCampaignForm', 'isLoading']),
    shouldDisableSubmitButton() {
      return this.isLoading || this.disableSubmit || !this.valid;
    },
    isFixCampaign() {
      return ['campaign_twilio_failed', 'campaign_tcr_failed'].includes(this.registrationStatus10dlc);
    },
  },
  methods: {
    ...mapActions('registerSoleProprietorA2p', [
      'setStep',
      'setCampaignForm',
      'sendSoleProprieterRegistration',
      'getRegistrationData',
      'setPreloadedCampaignForm',
    ]),
    ...mapMutations('registerSoleProprietorA2p', ['setIsLoading']),
    back() {
      this.setStep(this.steps.SOLE_PROPRIETOR);
    },
    async submit() {
      await this.setIsLoading(true);
      if (!this.$refs.form.validate()) return;
      this.setCampaignForm({ form: this.form });
      this.setPreloadedCampaignForm({ form: this.form });
      await this.sendSoleProprieterRegistration();
      this.$emit('form:save');
      this.setIsLoading(false);
    },
    getForm() {
      if (this.preloadedCampaignForm) {
        this.form = Object.assign(this.form, this.preloadedCampaignForm);
      }
    },
  },
};
</script>
<style scoped>
h3 {
  font-size: 14px !important;
}

.actions {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.title-step {
  font-size: 16px !important;
  line-height: 25px;
}

.fee-text {
  background-color: #dee7f1;
  border-radius: 10px;
  font-weight: 500;
  font-size: 16px;
}

.fee-list {
  list-style-type: none;
}

.row-thin {
  margin-top: -10px !important;
}

.retry-button {
  text-transform: none;
}
</style>
